import api from './api';

class ProcurementService {
  constructor() {
    this.loading = false;
    this.error = null;
  }

  // Confirm RFQ unlock with OTPs
  async confirmUnlock(procurementId, otps) {
    this.loading = true;
    this.error = null;
    
    try {
      const response = await api.post('/api/procurement/confirm-unlock', {
        procurement_id: procurementId,
        otps: otps
      });
      
      return response.data;
    } catch (error) {
      this.error = error.message || 'Failed to confirm unlock';
      console.error('Error confirming unlock:', error);
      throw error;
    } finally {
      this.loading = false;
    }
  }

  // Get approvers for RFQ unlock
  async getApprovers(procurementId) {
    this.loading = true;
    this.error = null;
    
    try {
      const response = await api.get(`/api/procurement/approvers/${procurementId}`);
      
      return response.data;
    } catch (error) {
      this.error = error.message || 'Failed to get approvers';
      console.error('Error getting approvers:', error);
      throw error;
    } finally {
      this.loading = false;
    }
  }

  // Resend OTP to approver
  async resendOTP(userId, procurementId, key) {
    this.loading = true;
    this.error = null;
    
    try {
      const response = await api.post('/api/procurement/resend-otp', {
        user_id: userId,
        procurement_id: procurementId,
        key: key
      });
      
      return response.data;
    } catch (error) {
      this.error = error.message || 'Failed to resend OTP';
      console.error('Error resending OTP:', error);
      throw error;
    } finally {
      this.loading = false;
    }
  }

  // Generate a secure supplier link for the RFQ portal
  async generateSupplierLink(procurementRef, supplierCode, supplierName) {
    console.log('=== PROCUREMENT SERVICE: generateSupplierLink ===');
    console.log('Input parameters:');
    console.log('- procurementRef:', procurementRef);
    console.log('- supplierCode:', supplierCode);
    console.log('- supplierName:', supplierName);
    
    this.loading = true;
    this.error = null;
    
    try {
      const requestData = {
        procurement_ref: procurementRef,
        supplier_code: supplierCode,
        supplier_name: supplierName
      };
      
      console.log('Request payload:', requestData);
      console.log('Making API call to: /api/procurement/generate-supplier-link');
      
      const response = await api.post('/api/procurement/generate-supplier-link', requestData);
      
      console.log('API response received:');
      console.log('- response.status:', response.status);
      console.log('- response.data:', response.data);
      
      // Return the actual data part of the response
      // The API returns: { status: 1, message: "...", data: { url: "...", encryptedRef: "...", ... } }
      // We want to return just the data part: { url: "...", encryptedRef: "...", ... }
      return response.data.data || response.data;
    } catch (error) {
      console.log('=== API CALL FAILED ===');
      console.log('Error details:', error);
      console.log('Error message:', error.message);
      console.log('Error response status:', error.response?.status);
      console.log('Error response data:', error.response?.data);
      
      this.error = error.message || 'Failed to generate supplier link';
      console.error('Error generating supplier link:', error);
      throw error;
    } finally {
      this.loading = false;
      console.log('=== PROCUREMENT SERVICE: generateSupplierLink END ===');
    }
  }

  // Get RFQ details for supplier portal
  async getSupplierRFQ(encryptedRef, sid, s) {
    this.loading = true;
    this.error = null;
    
    try {
      const response = await api.get(`/api/procurement/supplier/rfq/${encryptedRef}`, {
        params: { SID: sid, S: s }
      });
      
      return response.data;
    } catch (error) {
      this.error = error.message || 'Failed to fetch supplier RFQ';
      console.error('Error fetching supplier RFQ:', error);
      throw error;
    } finally {
      this.loading = false;
    }
  }

  // Unlock RFQ for viewing quotations before closing date
  async unlockRFQ(procurementId) {
    this.loading = true;
    this.error = null;
    
    try {
      const response = await api.post('/api/procurement/unlock', {
        procurement_id: procurementId
      });
      
      return response.data;
    } catch (error) {
      this.error = error.message || 'Failed to unlock RFQ';
      console.error('Error unlocking RFQ:', error);
      throw error;
    } finally {
      this.loading = false;
    }
  }

  // Confirm RFQ unlock with OTPs
  async confirmUnlockRFQ(procurementId, otps) {
    this.loading = true;
    this.error = null;
    
    try {
      const response = await api.post('/api/procurement/confirm-unlock', {
        procurement_id: procurementId,
        otps: otps
      });
      
      return response.data;
    } catch (error) {
      this.error = error.message || 'Failed to confirm unlock';
      console.error('Error confirming unlock:', error);
      throw error;
    } finally {
      this.loading = false;
    }
  }

  // Get approvers for RFQ unlock
  async getApprovers(procurementId) {
    this.loading = true;
    this.error = null;
    
    try {
      const response = await api.get(`/api/procurement/approvers/${procurementId}`);
      
      return response.data;
    } catch (error) {
      this.error = error.message || 'Failed to get approvers';
      console.error('Error getting approvers:', error);
      throw error;
    } finally {
      this.loading = false;
    }
  }
}

export default new ProcurementService();
